import { committeeMemberUpdateApi } from "../../api/committeeMember/committeeMemberUpdateApi"

type PayloadShape = Parameters<typeof committeeMemberUpdateApi>[0]

export async function committeeMemberUpdateService(payload: PayloadShape, token: string) {
	return await committeeMemberUpdateApi(payload, token)
}
